import { Controller } from "@hotwired/stimulus"

// Submits the controller's form whenever a bound control fires (e.g. a select or checkbox change).
// Used for immediate-commit edits: the form posts via Turbo and the server replaces the affected
// frame with a turbo_stream response.
//
// Usage:
//   <%= form_with ..., data: { controller: "auto-submit" } do |f| %>
//     <%= f.select ..., {}, data: { action: "change->auto-submit#submit" } %>
//   <% end %>
export default class extends Controller {
  submit() {
    this.element.requestSubmit()
  }
}
